import styled from 'styled-components';
import {
  blue,
  tekoMedium,
} from '../../../utils/theme';

import { mobile, tablet } from '../../../utils/breakpoints';


export const NewsGroupWrapper = styled.div`
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: right;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const NewsGroupInner = styled.div`
  margin: 0 auto;
  padding: 70px 0;
  max-width: 1200px;

  @media(max-width: ${mobile.max}px) {
    h1 {
      padding: 30px 30px 0 30px;
    }
  }


  h3.title {
    color: ${blue};
    ${tekoMedium} font-size: 60px;
    letter-spacing: 6.32px;
    text-transform: uppercase;
    text-align: center;

    @media (max-width: ${mobile.max}px) {
      font-size: 36px;
      padding-top: 24px;
    }
  }

  @media (max-width: ${mobile.max}px) {
    padding: 0
  }
`;

export const ArticleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
`;

export const CardWrapper = styled.div`
  flex-basis: 33%;
  padding: 5px;
  position: relative;
  height: auto;
  width: 100%;
  
  @media(max-width: ${tablet.max}px) {
    width: 50%;
    flex-basis: 50%;
  }
  @media(max-width: ${tablet.min}px) {
    width: 100%;
    flex-basis: 100%;
  }

  > p, div {
    width: 100%;
  }

  .article-card: {
    padding: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/news-group/styles/newsGroup.style.js